module.exports = __webpack_public_path__ + "img/20220112_121726.e4d5403e.jpg";